import { ModalSize } from './constants'
import { computed, ComputedRef } from 'vue'

export default function useModalClassName(
  size: ModalSize
): ComputedRef<string> {
  return computed(() => `sf-modal-${size}`)
}
